import { Link } from 'react-router-dom';
import Ill from '../../images/ill_christmas.jpg';
import BaseButton from '../Buttons/BaseButton';
import Seo from '../Seo';
type Props = {};

export default function Intro({}: Props) {
	return (
		<main className="text-white w-[80%] mx-auto p-8 flex flex-col gap-10 mt-52 mb-20">
			<Seo title="Christmas 2025" noIndex />
			<span className="text-customBlue font-bold text-4xl text-center">
				Nie do końca taki był plan jeśli chodzi o prezenty - nie planowałem
				bycia chorym w oraz przed świętami, ale no trzeba sobie jakoś radzić
			</span>
			<img
				src={Ill}
				alt="ill"
				className="mx-auto mb-8 rounded-lg shadow-lg shadow-gray-400/50 w-[40%] object-cover h-[400px]"
			/>

			<Link to="content" className="contents">
				<BaseButton className="mx-auto w-fit">Rozpocznij!</BaseButton>
			</Link>
		</main>
	);
}
